import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock, User } from "lucide-react";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.adminLogin({ username, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_user", res.data.username);
      toast.success("Acceso concedido");
      navigate("/admin/dashboard");
    } catch {
      toast.error("Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-medium text-white tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Merza Soluciones
          </h1>
          <p className="text-neutral-500 mt-2 text-sm tracking-widest uppercase">Z&M+Arquitectos — Panel de Administración</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="relative">
            <User className="absolute left-0 top-1/2 -translate-y-1/2 text-neutral-600" size={18} strokeWidth={1.5} />
            <input
              data-testid="admin-username-input"
              type="text"
              placeholder="Usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-transparent border-b border-neutral-800 focus:border-white text-white pl-8 pb-3 pt-1 text-lg outline-none transition-colors placeholder:text-neutral-600"
            />
          </div>

          <div className="relative">
            <Lock className="absolute left-0 top-1/2 -translate-y-1/2 text-neutral-600" size={18} strokeWidth={1.5} />
            <input
              data-testid="admin-password-input"
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-neutral-800 focus:border-white text-white pl-8 pb-3 pt-1 text-lg outline-none transition-colors placeholder:text-neutral-600"
            />
          </div>

          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="w-full bg-white text-black py-4 rounded-full text-sm font-medium tracking-wide hover:bg-neutral-200 transition-all active:scale-[0.98] disabled:opacity-50 mt-8"
          >
            {loading ? "Verificando..." : "Ingresar"}
          </button>
        </form>

        <p className="text-center text-neutral-700 text-xs mt-8">
          Acceso restringido a personal autorizado
        </p>
      </div>
    </div>
  );
}
